module.exports = __webpack_public_path__ + "static/media/Mask Group 8.c0105576.png";